import { computed } from "@angular/core";
import { signalStoreFeature, withComputed } from "@ngrx/signals";
import { IUserProfileState } from "./user-profile.state";
import { type } from "@ngrx/signals";
import { pickPrimaryRoleName } from "../../utils/primary-role.util";

export const withUserProfileComputed = signalStoreFeature(
    { state: type<IUserProfileState>() },
    withComputed(({ userProfile }) => ({
        firstName: computed(() => userProfile()?.displayName?.split(' ')[0] ?? ''),
        lastName: computed(() => userProfile()?.displayName?.split(' ')[1] ?? ''),
        initials: computed(() => {
            const firsName = userProfile()?.displayName?.split(' ')[0] ?? '';
            const lastName = userProfile()?.displayName?.split(' ')[1] ?? '';
            return `${firsName.charAt(0) ?? ''}${lastName.charAt(0) ?? ''}`.toUpperCase();
        }),
        fullName: computed(() => userProfile()?.displayName ?? ''),
        // Header shows one role — highest privilege (Employee is base and omitted when a higher role exists).
        roleName: computed(() => {
            const profile = userProfile();
            if (!profile) return '';
            const fromRoles = (profile.userRoles ?? [])
                .map((r) => r.roleName)
                .filter(Boolean);
            return pickPrimaryRoleName(fromRoles.length > 0 ? fromRoles : profile.roleName);
        }),
        emailAddress: computed(() => userProfile()?.emailAddress ?? ''),
        avatar: computed(() => userProfile()?.avatar ?? ''),
        userName: computed(() => userProfile()?.userName ?? ''),
        userProfileGuid: computed(() => userProfile()?.userProfileGuid ?? ''),
        userRoles: computed(() => userProfile()?.userRoles ?? []),
        employeeGuid: computed(() => userProfile()?.employeeGuid ?? ''),
        isActive: computed(() => userProfile()?.isActive ?? false),
        isEmailVerified: computed(() => userProfile()?.isEmailVerified ?? false),
        hasProfile: computed(() => userProfile() !== null),
        profileRole: computed(() => {
            const profile = userProfile();
            if (!profile) return null;
            const fromRoles = (profile.userRoles ?? [])
                .map((r) => r.roleName)
                .filter(Boolean);
            return {
                userRoleId: profile.userRoleId,
                roleId: profile.roleId,
                roleName: pickPrimaryRoleName(fromRoles.length > 0 ? fromRoles : profile.roleName),
                userRoles: profile.userRoles ?? [],
            };
        }),
        roleFeatures: computed(() => {
            const profile = userProfile();
            if (!profile) return [];
            return profile.roleFeatures ?? [];
        }),
        planKey: computed(() => userProfile()?.planKey ?? null),
        hasEmployeeSelfService: computed(() => userProfile()?.hasEmployeeSelfService !== false),
        mustChangePassword: computed(() => userProfile()?.mustChangePassword === true),
    }))
);
